export const IdentityPublicPath = {
  DELETION_EMAIL_START: '/api/v1/public/sp/account/deletion/email/start',
  DELETION_EMAIL_VERIFY: '/api/v1/public/sp/account/deletion/email/verify',
  DELETION_EMAIL_RESEND: '/api/v1/public/sp/account/deletion/email/resend',
} as const

export const IdentitySpAccountDeletionPath = {
  STATUS: '/api/v1/sp/account/deletion/status',
  CANCEL: '/api/v1/sp/account/deletion/cancel',
} as const

export const DELETE_ACCOUNT_EMAIL_STATE_KEY = 'deleteAccountEmail' as const

export { DEFAULT_GRACE_DAYS } from './deletion-disclosure'

export function readDeleteAccountEmailFromState(state: unknown): string | null {
  if (!state || typeof state !== 'object') return null
  const raw = (state as Record<string, unknown>)[DELETE_ACCOUNT_EMAIL_STATE_KEY]
  return typeof raw === 'string' && raw.length > 0 ? raw : null
}
